import styled from "styled-components";

import { SearchCard } from "../styledComponents";

export const ProActorCard = styled(SearchCard)`
  .deathday {
    margin: 0;
    margin-top: 15px;
    font-weight: bold;
  }
`;
